import { useTheme } from '@emotion/react'
import BreadcrumbHeader from 'layout/BreadcrumbsHeader'
import React, { useState } from 'react'
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper'
import Apps from 'views/components/Apps'
import Resources from 'views/components/Resources'
import { Box } from '@mui/material'
import CustomTabs from 'ui-components/CustomTabs'
import { useMediaQuery } from '@mui/material'
import { makeStyles } from "@mui/styles"
import { TabContext, TabList, TabPanel } from '@mui/lab';

const useStyles = makeStyles((theme) => ({
    scrollTabs: {
        '& > .Mui-disabled.MuiTabs-scrollButtons': {
            display: 'none',
            transition: 'all 1s ease'
        }
    }
}));

const BackrrApps = ({tabValue = "tools"}) => {
    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
    const [activeTab, setActiveTab] = useState(tabValue ?? 'tools');
        const classes = useStyles();

    const appTabs = [
        {
            label: "Tools",
            value: "tools"
        },
        {
            label: "Resources",
            value: "resources"
        }
    ]

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue)
    }
    React.useEffect(() => {
        handleTabChange(null, tabValue)
    },[tabValue])

    return (
        <>
            <ThemeBGWrapper>
                <BreadcrumbHeader title={tabValue === "resources" ? "Resources" : "AI Insights"} sx={{ paddingBottom: 0 }} />
                <TabContext value={activeTab}>
                {/* <Box sx={{ paddingInline: { xs: '1rem', md: '2rem' } }}>
                    <CustomTabs 
                        data={appTabs} 
                        value={activeTab} 
                        handleChange={handleTabChange}
                 isSmallScreen={isSmallScreen} key={"Tabs Tabs"} sx={{ paddingTop: '1rem' }} bgColor={theme.palette.customColors.yellow_bg}
                        className={classes}
                    />
                </Box> */}
                
                <TabPanel value="tools" sx={{ paddingBlock: "1.5rem",  paddingInline: 0, height: '100%' }}>
                    {activeTab === 'tools' && <Apps />}
                    
                </TabPanel>
                <TabPanel value="resources" sx={{ paddingBlock: "1.5rem",  paddingInline: 0, height: '100%' }}>
                    {activeTab === 'resources' && <Resources />}
                    
                </TabPanel>
                </TabContext>
            </ThemeBGWrapper>
        </>
    )
}

export default BackrrApps